var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftExcelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.99,
    height: 53.943,
    viewBox: "0 0 57.99 53.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.174,
    y1: -6.066,
    x2: 0.826,
    y2: -4.936,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microsoft-excel-icon",
    transform: "translate(0 -17.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M142,212.416,119.07,208.37v29.894a2.473,2.473,0,0,0,2.472,2.472H161.1a2.473,2.473,0,0,0,2.472-2.472h0V227.25Z",
    transform: "translate(-105.584 -168.933)",
    fill: "#185c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M142,17.86H121.542a2.473,2.473,0,0,0-2.472,2.472h0V31.346L142,44.832l12.137,4.046,9.44-4.046V31.346Z",
    transform: "translate(-105.584)",
    fill: "#21a366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M119.07,136.93H142v13.486H119.07Z",
    transform: "translate(-105.584 -105.584)",
    fill: "#107c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M135.478,113.12H119.07v33.714h16.408a2.481,2.481,0,0,0,2.472-2.472v-28.77A2.48,2.48,0,0,0,135.478,113.12Z",
    transform: "translate(-105.584 -84.471)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M134.13,125.02H119.07v33.715h15.06a2.481,2.481,0,0,0,2.472-2.472v-28.77A2.482,2.482,0,0,0,134.13,125.02Z",
    transform: "translate(-105.584 -95.023)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M134.13,125.02H119.07v31.017h15.06a2.481,2.481,0,0,0,2.472-2.472V127.492A2.482,2.482,0,0,0,134.13,125.02Z",
    transform: "translate(-105.584 -95.023)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M132.781,125.02H119.07v31.017h13.711a2.481,2.481,0,0,0,2.472-2.472V127.492A2.481,2.481,0,0,0,132.781,125.02Z",
    transform: "translate(-105.584 -95.023)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M2.472,125.02H27.2a2.473,2.473,0,0,1,2.472,2.472v24.725a2.473,2.473,0,0,1-2.472,2.472H2.472A2.472,2.472,0,0,1,0,152.217V127.492A2.472,2.472,0,0,1,2.472,125.02Z",
    transform: "translate(0 -95.023)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M67.6,201.12l5.2-8.057-4.765-8.013h3.833l2.6,5.125c.24.487.4.848.494,1.087H75q.257-.583.539-1.132l2.779-5.077h3.519l-4.886,7.966,5.009,8.1H78.212l-3-5.624a4.71,4.71,0,0,1-.359-.751h-.044a3.613,3.613,0,0,1-.348.728l-3.092,5.648-3.766,0Z",
    transform: "translate(-59.944 -148.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M340.595,17.86h-19.1V31.346h21.577V20.332a2.472,2.472,0,0,0-2.472-2.472Z",
    transform: "translate(-285.078)",
    fill: "#33c481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M321.49,256h21.577v13.486H321.49Z",
    transform: "translate(-285.078 -211.168)",
    fill: "#107c41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcelIcon);
export default __webpack_public_path__ + "static/media/microsoft-excel-icon.ec246afa63b532ead7b595cd747566c1.svg";
export { ForwardRef as ReactComponent };